module.exports = __webpack_public_path__ + "img/plan.6c8f4ae0.png";